import Vue from 'vue';
import svg_pan_zoom from 'svg-pan-zoom';
import { EventBus } from './EventBus';
import props from './props';

export default Vue.component('svg-viewer', {
		template: '<div class="svg-viewer-container" ref="svgviewer"><slot></slot><div v-if="htmlControls" class="controls"><button class="zoomin_btn" type="button" @click="spz.zoomIn()">+</button><button class="zoomout_btn" type="button" @click="spz.zoomOut()">–</button></div></div>',
		beforeCreate() {
		},
      data: function () {
        return {
          map: null,
          spz: null, 
          bus: EventBus(),
        }
      },

      props,

      components: {
        svg_pan_zoom
      },
      directives: {
      },
    	mounted: function() {

        let options = {};

        Object.keys(props).filter( k => this[k] !== undefined ).forEach( k => options[k] = this[k] );

        options.onZoom = (...args) => {
            this.bus.$emit( 'mainZoom' );
            if( this.onZoom ) this.onZoom(args);
        };

        options.onPan = (...args) => {
            this.bus.$emit( 'mainPan' );
            if( this.onPan ) this.onPan(args);
        };

        options.customEventsHandler = window.eventsHandler;

        this.spz = svg_pan_zoom( this.$slots.default[0].elm , options );

        this.$emit( 'svgpanzoom', this.spz );

        this.addResizeObserver();

    	},
      beforeDestroy () {
      },
      created() {

      },
    	computed: {

        options: function() {
            let options = {};

            const is_defined = k => this[k] !== undefined;

            Object.keys(props)
                .filter( is_defined )
                .forEach( k => options[k] = this[k] );

            return options;
        }

    	},

    	methods: {

        addResizeObserver(){

          const resizeObserver = new ResizeObserver((entries) => {

            this.spz.resize();
            this.spz.fit();
            this.spz.center();
          
          });

          resizeObserver.observe(this.$refs.svgviewer);

        }

      }

    });
